import ApiDatabase from 'server';
import UseContext from 'hooks/useContext';
import Modalheader from 'components/modal/components/header';
import ModalBody from 'components/modal/components/body';
import PerimeterModalFooter from 'components/modal/dataModal/data/perimeter/PerimeterModalFooter';
import usePerimeterModal from 'components/modal/dataModal/data/perimeter/usePerimeterModal';
import {
  fillText,
  getCountText,
  perimeterText,
} from 'components/perimeter/perimeterText';

// A restored perimeter comes back without any member, and its finished
// missions are restricted to it again: until members are attached, only the
// unrestricted ones see them. Hence the confirmation before the request.
const RestorePerimeterModal = () => {
  const { language } = UseContext();
  const t = (key) => perimeterText(language, key);
  const { data, isSaving, setIsSaving, close, succeed, fail } =
    usePerimeterModal();
  const { idCompany, perimeter, usage } = data;
  const finishedMissions = Number(usage?.finishedMissions) || 0;

  const handleConfirm = () => {
    if (isSaving) return;
    setIsSaving(true);
    ApiDatabase.postRestoreAdminCompanyPerimeter(
      { idCompany, id: perimeter?.id },
      () => succeed(fillText(t('toast.restored'), { name: perimeter?.name })),
      (err) => fail(err),
    );
  };

  return (
    <>
      <Modalheader hide={close} hideShow={true}>
        {fillText(t('restore.title'), { name: perimeter?.name })}
      </Modalheader>
      <ModalBody>
        <p className={'text-sm text-gray-600'}>
          {getCountText(language, 'restore.description', finishedMissions)}
        </p>
      </ModalBody>
      <PerimeterModalFooter
        confirmLabel={t('archived.restore')}
        savingLabel={t('restore.restoring')}
        isSaving={isSaving}
        onCancel={close}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default RestorePerimeterModal;
